import React, { useCallback } from "react";
import { useTranslations } from "@src/packages/i18n";
import { useBasicInfo } from "../BasicInfoContext";
import { BasicInfoQuestionLayout, YesNoOptions } from "../components";
import { useNavigation } from "@react-navigation/native";
import { usePatient } from "@src/packages/patients/hooks/usePatient";
import { useQueuedPatientUpdate } from "@src/packages/patients/sync/usePatientSync";

export function CancerScreen() {
  const t = useTranslations();
  const { state, updateState, next } = useBasicInfo("Cancer");
  const navigation = useNavigation();
  const { data: patient } = usePatient();
  const { mutateAsync: updatePatient, isPending } = useQueuedPatientUpdate();

  const selection = state.hasCancerHistory ?? null;

  const handleSelection = useCallback(
    async (value: boolean) => {
      const stateUpdates = { hasCancerHistory: value };
      updateState(stateUpdates);
      try {
        await updatePatient({
          medicalHistory: {
            id: patient?.medicalHistory?.id,
            hasCancerHistory: value,
          },
        });
      } catch {
        return;
      }

      if (selection === null) {
        next(stateUpdates);
      }
    },
    [next, selection, updateState, updatePatient, patient?.medicalHistory?.id],
  );

  return (
    <BasicInfoQuestionLayout
      route="Cancer"
      title={t("med_history.basic_info.cancer.title")}
      subtitle={t("med_history.basic_info.cancer.subtitle")}
      helpText={t("med_history.basic_info.help.cancer")}
      onBack={() => navigation.goBack()}
      onSave={() => next()}
      saveDisabled={selection === null || isPending}
      hideSaveButton={selection === null}
      saveLabel={t("med_history.shared.next")}
    >
      <YesNoOptions
        noLabel={t("med_history.shared.no")}
        onChange={handleSelection}
        value={selection}
        yesLabel={t("med_history.shared.yes")}
      />
    </BasicInfoQuestionLayout>
  );
}

export default CancerScreen;
